<template>
  <BaseScreen v-bind="screen">
    <BaseAlert
      v-if="isErrorVisible"
      v-bind="error"
      slot="middle"
    />
    <div
      v-else
      class="screen__row screen__account-info"
      slot="middle"
    >
      <div class="screen__col screen__col_side">
        <div class="doc">
          <img src="@/assets/images/doc.jpg" alt="">
        </div>
      </div>
      <div class="screen__col">
        <BaseText
          v-bind="note"
        />
        <BaseForm
          ref="form"
          v-bind="form"
          class="screen__gap screen__gap_half"
          @submit="onFormSubmit"
        />
      </div>
    </div>
  </BaseScreen>
</template>

<script>
import CONSTANTS from '@/helpers/constants';

import screenMixin from '@/mixins/screen';
import formMixin from '@/mixins/form';

import BaseText from '@/components/BaseText.vue';
import FieldAccount from '@/components/FieldAccount.vue';

export default {
  name: 'GuestAccountScreen',
  mixins: [screenMixin, formMixin],
  components: {
    BaseText,
  },
  data() {
    return {
      values: {
        account: '',
      },
    };
  },
  computed: {
    titleText() {
      return this.$t('titles.sendInfo');
    },
    screenCase() {
      return this.isErrorVisible
        ? CONSTANTS.STEP_BAD_DATE
        : CONSTANTS.STEP_GUEST_ACCOUNT;
    },
    note() {
      return {
        text: this.$t('texts.enterAccountNumber', {
          length: CONSTANTS.ACCOUNT_FIELD_LENGTH,
        }),
        size: 's',
        theme: 'note',
      };
    },
    form() {
      return {
        values: this.values,
        fields: [
          {
            is: FieldAccount,
            name: 'account',
          },
        ],
        actions: [
          {
            text: this.$t('actions.home'),
            action: this.goToHomeScreen,
            view: 'outlined',
          },
          {
            type: 'submit',
            text: this.$t('actions.continue'),
            disabled: this.isSubmitDisabled,
          },
        ],
        alignActions: 'left',
      };
    },
    error() {
      return {
        icon: {
          name: 'important',
          theme: 'secondary',
          size: 'l',
        },
        title: {
          text: this.$t('titles.sendInfoNotPossible'),
          size: 'l',
        },
        description: {
          text: this.$t('texts.sendInfoNotPossible', {
            minDay: CONSTANTS.SEND_METER_MIN_DAY,
            maxDay: CONSTANTS.SEND_METER_MAX_DAY,
          }),
          size: 'l',
        },
        actions: [
          {
            text: this.$t('actions.home'),
            action: this.goToHomeScreen,
            view: 'outlined',
          },
        ],
      };
    },
    isExpired() {
      const currentDay = new Date().getDate();
      return currentDay < CONSTANTS.SEND_METER_MIN_DAY
      || currentDay > CONSTANTS.SEND_METER_MAX_DAY;
    },
    isSubmitDisabled() {
      return Object.entries(this.values)
        .find(([, value]) => value === '');
    },
  },
  created() {
    this.checkDate();
  },
  methods: {
    checkDate() {
      return this.isExpired ? this.showError() : null;
    },
    onFormSubmit() {
      const { account } = this.values;
      return this.$router.push({
        path: this.$router.options.paths.guestMeter,
        query: { account },
      });
    },
  },
};
</script>
